import { DatePicker } from "antd";
import dayjs from "dayjs";

const ListDatePicker = ({ title, value, onChange }) => (
  <DatePicker
    inputReadOnly
    placeholder={title}
    format="DD-MM-YYYY"
    value={value ? dayjs(value) : null}
    onChange={onChange}
    style={{
      display: "block",
    }}
  />
);

export default ListDatePicker;
